import { WidgetUserTypeEnum } from '../models/widget-user-type.enum';
import { WidgetUrlConfig } from 'src/app/widget-config/initial-config';
import { UIConfig } from 'src/app/shared/widget-wiring';

export class WidgetStateModel {
    userType: WidgetUserTypeEnum;
    authenticating: boolean;
    authenticated: boolean;
    widgetUrlConfig: WidgetUrlConfig;
    widgetApiConfig: UIConfig;

    parentUrl: {
        full: string,
        domain: string
    };
    embedded: boolean;
    engineVersion: string;
    engineAPIVersion: string;

    inputEnabled: boolean;
}
